import {PropsWithChildren} from "react";

export function TitleTextBlock(props: PropsWithChildren<{
    title: string;
    // drop the side margins so the content uses the full width of the page box.
    fullWidth?: boolean;
}>) {
    const sidePadding = props.fullWidth ? 0 : "15%";

    return (
        <div style={{
            display: "flex",
            flexDirection: "column",
            flex: 1,
            paddingLeft: sidePadding,
            paddingRight: sidePadding,
        }}>
            <div style={{height: 20}} />
            <div style={{
                borderBottom: "1px solid black",
                borderTop: "1px solid black",
                fontSize: "1.2rem",
                textAlign: "center",
                fontWeight: "bold",
                width: "100%",
            }}>
                {props.title}
            </div>
            <div style={{height: 16}} />

            <div style={{paddingLeft: 10, paddingRight: 10, display: "flex", flexDirection: "column", flex: 1}}>
                {props.children}
            </div>
        </div>
    )
}